import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

interface StepListProps {
  steps: string[];
  style: {
    theme: string;
    entrance: "flyIn" | "slideUp";
    highlightColor?: string;
  };
}

const StepItem: React.FC<{
  step: string;
  index: number;
  totalSteps: number;
  frame: number;
  fps: number;
  activeIndex: number;
  theme: string;
  entrance: "flyIn" | "slideUp";
}> = ({ step, index, totalSteps, frame, fps, activeIndex, theme, entrance }) => {
  const isActive = index === activeIndex;
  const isPast = index < activeIndex;
  void(index > activeIndex); // isFuture — unused but kept for readability

  // 每个步骤延迟 15 帧入场
  const localFrame = frame - index * 15;

  if (localFrame < 0) {
    return null;
  }

  const enterProgress = spring({
    frame: localFrame,
    fps,
    config: { damping: 14, mass: 0.7, stiffness: 100 },
    durationInFrames: 25,
  });

  const opacity = interpolate(enterProgress, [0, 0.3, 1], [0, 1, 1]);

  // flyIn: 从左飞入, slideUp: 从底上移
  const offset = entrance === "slideUp"
    ? interpolate(enterProgress, [0, 1], [80, 0])
    : interpolate(enterProgress, [0, 1], [-120, 0]);

  const transform = entrance === "slideUp"
    ? `translateY(${offset}px)`
    : `translateX(${offset}px)`;

  // 当前步骤弹入后的放大效果
  const activeScale = isActive
    ? 1 + 0.08 * Math.sin(frame * 0.15)
    : isPast ? 0.85 : 1;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 20,
        transform,
        opacity: isPast ? 0.5 : opacity,
        marginBottom: 16,
        transition: "opacity 0.3s ease",
      }}
    >
      {/* 序号胶囊 */}
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: isActive
            ? theme
            : `rgba(0,245,255,0.15)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 22,
          fontWeight: 800,
          color: isActive ? "#00F5FF" : "rgba(0,245,255,0.4)",
          fontFamily: "sans-serif",
          boxShadow: isActive ? `0 0 30px ${theme}60` : "none",
          flexShrink: 0,
        }}
      >
        {index + 1}
      </div>

      {/* 步骤文字 */}
      <div
        style={{
          fontSize: 36,
          fontWeight: 700,
          color: isActive ? "#00F5FF" : "rgba(0,245,255,0.4)",
          fontFamily: "sans-serif",
          transform: `scale(${activeScale})`,
          letterSpacing: "1px",
        }}
      >
        {step}
      </div>
    </div>
  );
};

const StepList: React.FC<StepListProps> = ({ steps, style }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // 计算当前活跃步骤索引
  const activeIndex = Math.min(
    Math.floor(frame / 15),
    steps.length - 1,
  );

  return (
    <AbsoluteFill
      style={{
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#0a0a0a",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "70%",
          maxWidth: 700,
        }}
      >
        {steps.map((step, i) => (
          <StepItem
            key={i}
            step={step}
            index={i}
            totalSteps={steps.length}
            frame={frame}
            fps={fps}
            activeIndex={activeIndex}
            theme={style.theme}
            entrance={style.entrance}
          />
        ))}
      </div>
    </AbsoluteFill>
  );
};

export default StepList;
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
